import { gql } from '@apollo/client';

export const INTEGRATION_OUTBOUND_FIELDS = gql`
    fragment IntegrationOutboundFields on integrations_outbound {
        id
        transaction_id
        transaction_type
        entity_type
        status
        created_at
    }
`;
